export default __webpack_public_path__ + "static/media/redarrow-icon.9167ee44.svg";